import { createStrictOptionalContext } from 'helpers/context';
import React, { PropsWithChildren, useEffect, useState } from 'react';

const { Provider: IsOfflineProvider, useRequiredContext: useIsOffline } =
  createStrictOptionalContext<boolean>('useIsOffline', 'WithIsOffline');

export { useIsOffline };

export const WithIsOffline: React.FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const [isOfflineState, setIsOfflineState] = useState<boolean>(false);

  useEffect(() => {
    //TODO this is just a naive, mocked implementation that should be fixed in PT-3470 ~SM
    const setOffline = (): void => {
      setIsOfflineState(true);
    };
    const setOnline = (): void => {
      setIsOfflineState(false);
    };

    window.addEventListener('online', setOnline);
    window.addEventListener('offline', setOffline);

    return (): void => {
      window.removeEventListener('online', setOnline);
      window.removeEventListener('offline', setOffline);
    };
  }, []);

  return (
    <IsOfflineProvider value={isOfflineState}>
      {children}
    </IsOfflineProvider>
  );
};
